import script from "./ModifySuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./ModifySuccess.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__